import React, { useState, useEffect } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import axios from '../../axios/axiosconf';
import Header from '../general/Header';
import Aside from '../general/Aside';
import Footer from '../general/Footer';
import Unauthorized from '../general/Unauthorized';

function CrearFacturaRips() {
    const location = useLocation();
    const history = useHistory();
    const [loading, setLoading] = useState(true);
    const [hasPermission, setHasPermission] = useState(false);
    
    // IDs de RIPS seleccionados (vienen desde RipsConvenios)
    const [ripsIds, setRipsIds] = useState([]);
    
    // Datos del formulario
    const [fecha, setFecha] = useState(new Date().toISOString().split('T')[0]);
    const [vencimiento, setVencimiento] = useState(new Date().toISOString().split('T')[0]);
    const [profesional, setProfesional] = useState('');
    const [sede, setSede] = useState('');
    const [prefijo, setPrefijo] = useState('');
    const [numeroFactura, setNumeroFactura] = useState('');
    const [metodoPago, setMetodoPago] = useState('10');
    const [tipoPago, setTipoPago] = useState('contado');
    const [observaciones, setObservaciones] = useState('');
    
    // Datos del paciente (se cargan automáticamente)
    const [pacienteId, setPacienteId] = useState('');
    const [nombrePaciente, setNombrePaciente] = useState('');
    const [tipoPaciente, setTipoPaciente] = useState('CC');
    const [documentoPaciente, setDocumentoPaciente] = useState('');
    const [codigoResponsabilidad, setCodigoResponsabilidad] = useState('No responsable');
    const [codigoRegimen, setCodigoRegimen] = useState('No responsable de IVA');
    const [codigoImpuesto, setCodigoImpuesto] = useState('No causa');
    
    // Productos (servicios de los RIPS)
    const [productos, setProductos] = useState([]);
    const [totalBruto, setTotalBruto] = useState(0);
    const [totalPagar, setTotalPagar] = useState(0);
    
    // Datos de API
    const [profesionales, setProfesionales] = useState([]);
    const [parametrosFev, setParametrosFev] = useState([]);
    const [sedes, setSedes] = useState([]);
    const [impuestos, setImpuestos] = useState([]);
    
    // Modal de pacientes
    const [showModalPaciente, setShowModalPaciente] = useState(false);
    const [pacientes, setPacientes] = useState([]);
    const [busquedaPaciente, setBusquedaPaciente] = useState('');
    const [paginaActual, setPaginaActual] = useState(1);
    const pacientesPorPagina = 10;

    useEffect(() => {
        // Validar permisos primero
        let userdata = [];
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // Verificar si tiene permiso para administrar RIPS
        const tienePermiso = userdata.up && userdata.up.includes('administrarRips');
        
        if (!tienePermiso) {
            setHasPermission(false);
            return; // Detener ejecución si no tiene permisos
        }

        setHasPermission(true);

        // Obtener IDs de RIPS desde la URL
        const params = new URLSearchParams(location.search);
        const ids = params.get('rips_ids');
        
        if (ids) {
            const idsArray = ids.split(',').map(id => parseInt(id));
            setRipsIds(idsArray);
            cargarDatosIniciales(idsArray);
        } else {
            alert('No se especificaron RIPS para facturar');
            window.location.href = '/#/rips-convenios';
        }
    }, [location.search]);

    const cargarDatosIniciales = async (idsArray) => {
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        
        try {
            // Cargar datos generales
            const [profResponse, fevResponse, sedesResponse, impuestosResponse, pacientesResponse] = await Promise.all([
                axios.get('/usuarios?uid=' + userdata.user_id),
                axios.get('/parametros-fev?uid=' + userdata.user_id),
                axios.get('/sedes?uid=' + userdata.user_id),
                axios.get('/administrador-impuestos'), // Tabla maestra - sin filtro por client_id
                axios.get('/pacientes?uid=' + userdata.user_id)
            ]);
            
            setProfesionales(profResponse.data);
            setParametrosFev(fevResponse.data);
            setSedes(sedesResponse.data);
            setImpuestos(impuestosResponse.data);
            setPacientes(pacientesResponse.data);
            
            // Cargar datos de los RIPS seleccionados
            const ripsResponse = await axios.get('/rips-convenio/detalle', {
                params: {
                    uid: userdata.user_id,
                    rips_ids: idsArray.join(',')
                }
            });
            
            const ripsData = ripsResponse.data;
            
            if (ripsData.length === 0) {
                alert('No Hay Datos Disponibles Para La Selección Actual. Por Favor, Verifique Los Filtros De Los RIPS E Intente De Nuevo.');
                return;
            }
            
            // Cargar datos del profesional y sede desde el primer RIPS
            const primerRips = ripsData[0];
            setProfesional(primerRips.users_id);
            setSede(primerRips.sede_id);
            
            // NO cargar paciente automáticamente - el usuario debe seleccionarlo manualmente
            // Esto permite facturar a una entidad diferente (convenio) en lugar del paciente del RIPS
            
            // Convertir RIPS a productos
            const productosArray = ripsData.map(rips => ({
                id: rips.id,
                rips_id: rips.id,
                id_listadeprecios: rips.listaprecios_id,
                codigo: rips.codigo,
                descripcion: rips.nombre_servicio,
                cantidad: 1,
                precio: parseFloat(rips.valor_servicio),
                porcentaje: 0,
                impuesto: 0,
                total: parseFloat(rips.valor_servicio)
            }));
            
            setProductos(productosArray);
            calcularTotales(productosArray);
            setLoading(false);
            
        } catch (error) {
            console.error('Error Cargando Datos:', error);
            alert('Error Al Cargar Los Datos: ' + (error.response?.data?.message || error.message));
            setLoading(false);
        }
    };

    const handlePrefijoChange = (e) => {
        const selectedPrefijo = getPrefijosFiltrados().find(p => p.id == e.target.value);
        setPrefijo(e.target.value);
        if (selectedPrefijo) {
            setNumeroFactura(selectedPrefijo.numero_factura);
        }
    };

    const getPrefijosFiltrados = () => {
        return parametrosFev.filter(param => 
            param.tipo === 'Factura Electronica' && 
            param.users_id == profesional &&
            param.habilitado == 1
        );
    };

    const actualizarProducto = (id, campo, valor) => {
        const nuevosProductos = productos.map(p => {
            if (p.id === id) {
                const productoActualizado = { ...p, [campo]: parseFloat(valor) || 0 };
                
                // Recalcular total del producto
                const descuento = (productoActualizado.precio * productoActualizado.cantidad) * (productoActualizado.porcentaje / 100);
                const totalBase = (productoActualizado.precio * productoActualizado.cantidad) - descuento;
                const totalConImpuesto = totalBase + (totalBase * (productoActualizado.impuesto / 100));
                productoActualizado.total = totalConImpuesto;
                
                return productoActualizado;
            }
            return p;
        });
        setProductos(nuevosProductos);
        calcularTotales(nuevosProductos);
    };

    const calcularTotales = (productosArray) => {
        let bruto = 0;
        let pagar = 0;

        productosArray.forEach(producto => {
            bruto += (producto.precio * producto.cantidad);
            pagar += producto.total;
        });

        setTotalBruto(bruto);
        setTotalPagar(pagar);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (productos.length === 0) {
            alert('No Hay Servicios Para Facturar');
            return;
        }

        if (tipoPago === 'credito' && fecha === vencimiento) {
            alert('Para Crédito, La Fecha De Vencimiento Debe Ser Diferente A La Fecha Del Documento');
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));

        const facturaData = {
            parametrosfev_id: parseInt(prefijo),
            users_id: parseInt(profesional),
            paciente_id: parseInt(pacienteId),
            sedes_id: parseInt(sede),
            fecha_emision: fecha,
            fecha_vence: vencimiento,
            numero_factura: numeroFactura,
            forma_pago: metodoPago,
            tipo_pago: tipoPago,
            valor_bruto: parseFloat(totalBruto),
            valor_total: parseFloat(totalPagar),
            observaciones: observaciones || '',
            codigo_responsabilidad: codigoResponsabilidad,
            codigo_regimen: codigoRegimen,
            codigo_impuesto: codigoImpuesto,
            rips_ids: ripsIds, // IDs de RIPS para actualizar
            detalle: productos.map(producto => ({
                id_listadeprecios: parseInt(producto.id_listadeprecios),
                cantidad: parseInt(producto.cantidad),
                precio_unitario: parseFloat(producto.precio),
                porcentaje: parseFloat(producto.porcentaje),
                impuesto: parseFloat(producto.impuesto),
                total: parseFloat(producto.total)
            }))
        };

        try {
            const response = await axios.post('/rips-convenio/generar-factura', facturaData);
            
            if (response.status === 200 || response.status === 201) {
                const facturaId = response.data.factura_id;
                alert(`Factura ${response.data.prefijo}-${response.data.numero_factura} Creada Exitosamente`);
                
                // Preguntar si desea enviar a la DIAN
                const enviarDian = window.confirm('¿Desea Enviar La Factura A La DIAN? Esta Acción Generará El Documento Electrónico Oficial.?');
                
                if (enviarDian) {
                    try {
                        const envioResponse = await axios.post(`/factura/${facturaId}/enviar-dian`, {});
                        
                        if (envioResponse.data.success) {
                            alert('Factura Enviada Exitosamente A La DIAN');
                        } else {
                            alert('No Se Pudo Completar El Envío A La DIAN. Por Favor, Intente Nuevamente.: ' + envioResponse.data.message);
                        }
                    } catch (envioError) {
                        console.error('No Se Pudo Completar El Envío A La DIAN. Por Favor, Intente Nuevamente.', envioError);
                        alert('No Se Pudo Completar El Envío A La DIAN. Por Favor, Intente Nuevamente.: ' + (envioError.response?.data?.message || envioError.message));
                    }
                }
                
                // Redirigir al listado de facturas
                window.location.href = `/#/informacion-factura/${facturaId}`;
            }
        } catch (error) {
            console.error('Error completo:', error);
            alert('No Se Pudo Guardar La Factura. Por Favor, Inténtelo De Nuevo' + (error.response?.data?.message || error.message));
        }
    };

    const formatearValor = (valor) => {
        if (!valor || valor === 0) return '-';
        return '$' + Math.round(parseFloat(valor)).toLocaleString('es-CO');
    };

    const getPacientesFiltrados = () => {
        if (!busquedaPaciente) return pacientes;
        
        return pacientes.filter(paciente => {
            const nombreCompleto = `${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim().toLowerCase();
            const documento = paciente.numero_documento || '';
            const busqueda = busquedaPaciente.toLowerCase();
            
            return nombreCompleto.includes(busqueda) || documento.includes(busqueda);
        });
    };

    const getPacientesPaginados = () => {
        const pacientesFiltrados = getPacientesFiltrados();
        const inicio = (paginaActual - 1) * pacientesPorPagina;
        const fin = inicio + pacientesPorPagina;
        return pacientesFiltrados.slice(inicio, fin);
    };

    const getTotalPaginas = () => {
        return Math.ceil(getPacientesFiltrados().length / pacientesPorPagina);
    };

    const seleccionarPaciente = (paciente) => {
        const nombreCompleto = `${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim();
        setPacienteId(paciente.id);
        setNombrePaciente(nombreCompleto);
        setTipoPaciente(paciente.tipo_documento || 'CC');
        setDocumentoPaciente(paciente.numero_documento || '');
        setCodigoResponsabilidad(paciente.codigo_responsabilidad || 'No Responsable');
        setCodigoRegimen(paciente.codigo_regimen || 'No Responsable de IVA');
        setCodigoImpuesto(paciente.codigo_impuesto || 'No Causa');
        setShowModalPaciente(false);
    };

    if (loading) {
        return (
            <div className="hold-transition">
                <Header />
                <Aside activelink="indicators" />
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="text-center">
                                <div className="spinner-border" role="status">
                                    <span className="sr-only">Cargando...</span>
                                </div>
                                <p>Cargando Datos...</p>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }

    return (
        <div className="hold-transition">
            <Header />
            <Aside activelink="indicators" />
            
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0">Generar Factura desde RIPS</h1>
                            </div>
                            <div className="col-sm-6">
                                <Link to="/rips-convenios" className="btn btn-secondary float-right">
                                    <i className="fas fa-arrow-left"></i> Volver
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">
                        
                        <div className="card card-info card-outline">
                            <div className="card-header">
                                <h5><b>Información de la Factura</b></h5>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    
                                    <h5><b>Información del Paciente</b></h5>
                                    
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Nombre *</label>
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    value={nombrePaciente}
                                                    readOnly
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>Tipo *</label>
                                                <select 
                                                    className="form-control" 
                                                    value={tipoPaciente}
                                                    readOnly
                                                    required
                                                >
                                                    <option value="CC">CC</option>
                                                    <option value="CE">CE</option>
                                                    <option value="PA">PA</option>
                                                    <option value="PE">PE</option>
                                                    <option value="RC">RC</option>
                                                    <option value="TI">TI</option>
                                                    <option value="NIT">NIT</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>N° Documento *</label>
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    value={documentoPaciente}
                                                    readOnly
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-1">
                                            <div className="form-group">
                                                <label>&nbsp;</label>
                                                <button 
                                                    type="button" 
                                                    className="btn btn-info form-control"
                                                    onClick={() => setShowModalPaciente(true)}
                                                >
                                                    <i className="fas fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Responsabilidad *</label>
                                                <select 
                                                    className="form-control" 
                                                    value={codigoResponsabilidad}
                                                    onChange={(e) => setCodigoResponsabilidad(e.target.value)}
                                                    required
                                                >
                                                    <option>No responsable</option>
                                                    <option>Régimen simple de tributación</option>
                                                    <option>Gran contribuyente</option>
                                                    <option>Autorretenedor</option>
                                                    <option>Agente de retención IVA</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Tipo de Régimen *</label>
                                                <select 
                                                    className="form-control" 
                                                    value={codigoRegimen}
                                                    onChange={(e) => setCodigoRegimen(e.target.value)}
                                                    required
                                                >
                                                    <option>No responsable de IVA</option>
                                                    <option>Impuesto sobre las ventas / IVA</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Impuesto *</label>
                                                <select 
                                                    className="form-control" 
                                                    value={codigoImpuesto}
                                                    onChange={(e) => setCodigoImpuesto(e.target.value)}
                                                    required
                                                >
                                                    <option>No causa</option>
                                                    <option>IVA</option>
                                                    <option>INC</option>
                                                    <option>IVA e INC</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <hr />

                                    <h5><b>Datos de Factura</b></h5>

                                    <div className="row">
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>Fecha del Documento *</label>
                                                <input 
                                                    type="date" 
                                                    className="form-control" 
                                                    value={fecha}
                                                    onChange={(e) => {
                                                        setFecha(e.target.value);
                                                        if (tipoPago === 'contado') {
                                                            setVencimiento(e.target.value);
                                                        }
                                                    }}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>Tipo de Pago *</label>
                                                <select 
                                                    className="form-control" 
                                                    value={tipoPago}
                                                    onChange={(e) => {
                                                        setTipoPago(e.target.value);
                                                        if (e.target.value === 'contado') {
                                                            setVencimiento(fecha);
                                                        }
                                                    }}
                                                    required
                                                >
                                                    <option value="contado">Contado</option>
                                                    <option value="credito">Crédito</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>Vencimiento *</label>
                                                <input 
                                                    type="date" 
                                                    className="form-control" 
                                                    value={vencimiento}
                                                    onChange={(e) => setVencimiento(e.target.value)}
                                                    disabled={tipoPago === 'contado'}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Profesional *</label>
                                                <select 
                                                    className="form-control" 
                                                    value={profesional}
                                                    onChange={(e) => setProfesional(e.target.value)}
                                                    required
                                                >
                                                    <option value="">Seleccionar...</option>
                                                    {profesionales.map(prof => (
                                                        <option key={prof.id} value={prof.id}>{prof.name} {prof.lastname}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Sede *</label>
                                                <select 
                                                    className="form-control" 
                                                    value={sede}
                                                    onChange={(e) => setSede(e.target.value)}
                                                    required
                                                >
                                                    <option value="">Seleccionar...</option>
                                                    {sedes.map(s => (
                                                        <option key={s.id} value={s.id}>{s.nombre}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>Prefijo *</label>
                                                <select 
                                                    className="form-control" 
                                                    value={prefijo}
                                                    onChange={handlePrefijoChange}
                                                    required
                                                >
                                                    <option value="">Seleccionar...</option>
                                                    {getPrefijosFiltrados().map(p => (
                                                        <option key={p.id} value={p.id}>{p.prefijo}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>N° Factura *</label>
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    value={numeroFactura}
                                                    readOnly
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Metodo de Pago *</label>
                                                <select 
                                                    className="form-control" 
                                                    value={metodoPago}
                                                    onChange={(e) => setMetodoPago(e.target.value)}
                                                    required
                                                >
                                                    <option value="10">Efectivo</option>
                                                    <option value="42">Consignación Bancaria</option>
                                                    <option value="48">Tarjeta Crédito</option>
                                                    <option value="49">Tarjeta Débito</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <hr />

                                    <h5><b>Servicios de RIPS</b></h5>

                                    <div className="table-responsive">
                                        <table className="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th style={{width: '10%'}}>Código</th>
                                                    <th style={{width: '30%'}}>Descripción</th>
                                                    <th style={{width: '8%'}}>Cant.</th>
                                                    <th style={{width: '12%'}}>Precio</th>
                                                    <th style={{width: '8%'}}>% Desc</th>
                                                    <th style={{width: '15%'}}>Impuesto</th>
                                                    <th style={{width: '12%'}}>Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {productos.map(producto => (
                                                    <tr key={producto.id}>
                                                        <td>
                                                            <input 
                                                                type="text" 
                                                                className="form-control form-control-sm" 
                                                                value={producto.codigo}
                                                                readOnly
                                                            />
                                                        </td>
                                                        <td style={{fontSize: '14px', padding: '8px'}}>{producto.descripcion}</td>
                                                        <td>
                                                            <input 
                                                                type="number" 
                                                                className="form-control form-control-sm" 
                                                                value={producto.cantidad}
                                                                onChange={(e) => actualizarProducto(producto.id, 'cantidad', e.target.value)}
                                                                min="1"
                                                            />
                                                        </td>
                                                        <td>
                                                            <input 
                                                                type="number" 
                                                                className="form-control form-control-sm" 
                                                                value={producto.precio}
                                                                onChange={(e) => actualizarProducto(producto.id, 'precio', e.target.value)}
                                                                step="0.01"
                                                            />
                                                        </td>
                                                        <td>
                                                            <input 
                                                                type="number" 
                                                                className="form-control form-control-sm" 
                                                                value={producto.porcentaje}
                                                                onChange={(e) => actualizarProducto(producto.id, 'porcentaje', e.target.value)}
                                                                min="0"
                                                            />
                                                        </td>
                                                        <td>
                                                            <select 
                                                                className="form-control form-control-sm" 
                                                                value={producto.impuesto}
                                                                onChange={(e) => actualizarProducto(producto.id, 'impuesto', e.target.value)}
                                                            >
                                                                <option value="0">0</option>
                                                                {impuestos.map(imp => (
                                                                    <option key={imp.id} value={imp.impuesto}>{imp.nombre+' '+imp.impuesto+'%'}</option>
                                                                ))}
                                                            </select>
                                                        </td>
                                                        <td>
                                                            <input 
                                                                type="number" 
                                                                className="form-control form-control-sm" 
                                                                value={parseFloat(producto.total || 0).toFixed(2)}
                                                                readOnly
                                                            />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <td colSpan="6" className="text-right"><strong>SubTotal:</strong></td>
                                                    <td>
                                                        <input 
                                                            type="text" 
                                                            className="form-control" 
                                                            value={formatearValor(totalBruto)}
                                                            readOnly
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="6" className="text-right"><strong>Total a Pagar:</strong></td>
                                                    <td>
                                                        <input 
                                                            type="text" 
                                                            className="form-control" 
                                                            value={formatearValor(totalPagar)}
                                                            readOnly
                                                        />
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>

                                    <hr />

                                    <div className="form-group">
                                        <label>Observaciones</label>
                                        <textarea 
                                            className="form-control" 
                                            rows="3"
                                            value={observaciones}
                                            onChange={(e) => setObservaciones(e.target.value)}
                                            placeholder="Factura generada desde RIPS por convenio"
                                        />
                                    </div>

                                    <div className="form-group">
                                        <button type="submit" className="btn btn-success btn-lg">
                                            <i className="fas fa-save"></i> Generar Factura
                                        </button>
                                        <Link to="/rips-convenios" className="btn btn-secondary btn-lg ml-2">
                                            <i className="fas fa-times"></i> Cancelar
                                        </Link>
                                    </div>

                                </form>
                            </div>
                        </div>

                    </div>
                </section>
            </div>

            <Footer />

            {/* Modal para seleccionar paciente */}
            {showModalPaciente && (
                <div className="modal fade show" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.5)'}} tabIndex="-1">
                    <div className="modal-dialog modal-lg modal-dialog-scrollable">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Seleccionar Paciente</h5>
                                <button type="button" className="close" onClick={() => setShowModalPaciente(false)}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body" style={{maxHeight: '500px', overflowY: 'auto'}}>
                                <div className="form-group">
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        placeholder="Buscar por nombre o documento..."
                                        value={busquedaPaciente}
                                        onChange={(e) => {
                                            setBusquedaPaciente(e.target.value);
                                            setPaginaActual(1);
                                        }}
                                    />
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-bordered table-hover table-sm">
                                        <thead className="thead-light">
                                            <tr>
                                                <th>Nombre</th>
                                                <th>Documento</th>
                                                <th style={{width: '120px'}}>Acción</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {getPacientesPaginados().map((paciente, index) => (
                                                <tr key={index}>
                                                    <td>{`${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim()}</td>
                                                    <td>{paciente.numero_documento}</td>
                                                    <td>
                                                        <button 
                                                            type="button" 
                                                            className="btn btn-sm btn-primary"
                                                            onClick={() => seleccionarPaciente(paciente)}
                                                        >
                                                            Seleccionar
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                
                                {/* Paginación */}
                                {getTotalPaginas() > 1 && (
                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        <button 
                                            type="button" 
                                            className="btn btn-secondary btn-sm"
                                            disabled={paginaActual === 1}
                                            onClick={() => setPaginaActual(paginaActual - 1)}
                                        >
                                            <i className="fas fa-chevron-left"></i> Anterior
                                        </button>
                                        <span className="badge badge-info">Página {paginaActual} de {getTotalPaginas()}</span>
                                        <button 
                                            type="button" 
                                            className="btn btn-secondary btn-sm"
                                            disabled={paginaActual === getTotalPaginas()}
                                            onClick={() => setPaginaActual(paginaActual + 1)}
                                        >
                                            Siguiente <i className="fas fa-chevron-right"></i>
                                        </button>
                                    </div>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowModalPaciente(false)}>
                                    <i className="fas fa-times"></i> Cerrar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );

    // Si no tiene permisos, mostrar página de no autorizado
    if (hasPermission === false) {
        return <Unauthorized />;
    }
}

export default CrearFacturaRips;
